import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';
import { FieldMetadata, ViewMetadata } from '@data/cer-data-types';

export class WarehousePurchLineForm extends CerFormAdapter {

  override viewSetInit(viewSet: CerFormViewSet): void {
    const navProduct = this.routeOptions.navigation?.columnNameChild == 'productNum';
    
    const view = new CerFormView();
    view.viewMetadata = WarehousePurchLineForm.viewMetadata;
    view.fieldMetadata = WarehousePurchLineForm.fieldMetadata;
    if (navProduct) {
      const hideCols = ['productNum', 'productName'];
      view.fieldMetadata.filter(f => hideCols.includes(f.name)).forEach(f => f.visible = false);
      view.fieldMetadata.find(f => f.name == 'qty').footerType = 'Sum';
      view.viewMetadata.navigations = view.viewMetadata.navigations?.filter(f => f.foreignKey.parentEntity != 'RefDataProduct') ?? [];

    }
    
    viewSet.viewAdd(view);
  }

  public static viewMetadata: ViewMetadata = {
    name: 'lager-tilgange', dataApiName: 'WarehousePurchLine',
    text: 'Tilgange', titleFields: ['productNum', 'transDate'],
    allowEdit: false, allowDelete: false, allowCreate: false,
    primaryKey: 'id', baseFields: ['id'],
  };

  public static fieldMetadata: FieldMetadata[] = [
    { name: 'id', text: "Kontering id", format: 'Integer', width: '90px', visible: false },
    { name: 'transDate', text: "Dato", format: 'DateShort', width: '80px', orderBy: 'Descending' },
    { name: 'postingDate', text: "Bogført dato", format: 'DateShort', width: '80px', visible: false },
    { name: 'productNum', text: "ISBN", foreignKeyType: 'productLookup' },
    { name: 'productName', text: "Titel", foreignKeyUsing: 'productNum' },
    { name: 'qty', text: "Antal", format: 'Number' },
    { name: 'lineId', text: "Linje id", format: 'Integer', visible: false },
    { name: 'asn', text: "ASN", visible: false }


  ];
}
